import React from 'react';

export default function SpeakersHero({ heroData: hero }) {
    return (
        <section className="spk-hero">
            <style>{`
                .spk-hero {
                    position: relative;
                    padding: 160px 0 90px;
                    background: var(--eventflow-black);
                    overflow: hidden;
                    text-align: center;
                }
                .spk-hero::before {
                    content: '';
                    position: absolute; inset: 0;
                    background:
                        radial-gradient(ellipse at 50% 0%, rgba(var(--eventflow-primary-rgb),0.2) 0%, transparent 60%),
                        radial-gradient(ellipse at 20% 100%, rgba(var(--eventflow-base-rgb),0.1) 0%, transparent 50%);
                    pointer-events: none;
                }
                .spk-hero::after {
                    content: '';
                    position: absolute; inset: 0;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
                    background-size: 60px 60px;
                    pointer-events: none;
                }
                .spk-hero__inner { position: relative; z-index: 2; }
                .spk-hero__tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 20px;
                }
                .spk-hero__tag::before, .spk-hero__tag::after {
                    content: ''; display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .spk-hero__title {
                    font-family: var(--eventflow-font);
                    font-size: 68px; font-weight: 900;
                    color: #fff; line-height: 1.0;
                    letter-spacing: -2px; margin-bottom: 18px;
                }
                .spk-hero__title span {
                    background: linear-gradient(135deg, var(--eventflow-base) 0%, #ff4d9e 50%, var(--eventflow-primary) 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .spk-hero__sub {
                    font-family: var(--eventflow-font);
                    font-size: 17px; color: rgba(255,255,255,0.5);
                    max-width: 560px; margin: 0 auto 40px; line-height: 1.75;
                }
                .spk-hero__stats {
                    display: flex; justify-content: center;
                    gap: 12px; flex-wrap: wrap;
                }
                .spk-hero__stat {
                    display: inline-flex; align-items: center; gap: 8px;
                    background: rgba(255,255,255,0.04);
                    border: 1px solid rgba(255,255,255,0.08);
                    border-radius: 50px; padding: 9px 20px;
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.55);
                }
                .spk-hero__stat i { color: var(--eventflow-base); font-size: 12px; }
                .spk-hero__stat strong { color: #fff; font-weight: 700; }
                @media (max-width: 768px) {
                    .spk-hero { padding: 130px 0 60px; }
                    .spk-hero__title { font-size: 42px; letter-spacing: -1px; }
                }
            `}</style>
            <div className="container">
                <div className="spk-hero__inner wow fadeInUp" data-wow-delay="100ms">
                    <div className="spk-hero__tag">{hero.tag}</div>
                    <h1 className="spk-hero__title">
                        {hero.title}<span>{hero.titleAccent}</span>
                    </h1>
                    <p className="spk-hero__sub">
                        {hero.subtitle}
                    </p>
                    <div className="spk-hero__stats">
                        {(hero.stats || []).map((stat, i) => (
                            <span className="spk-hero__stat" key={i}>
                                <i className={`fa ${stat.icon}`} /><strong>{stat.value}</strong> {stat.label}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
